export default __webpack_public_path__ + "static/media/stats.b2d740be.svg";